import React, { useState } from "react";
import { Link } from "react-router-dom";
import { DataGrid, DataGridColumn } from "@/ui-controls/DataGrid";
import MoreActionsButton from "@/ui-controls/MoreActionsButton";
import { AuditRecord } from "@/api/audits";

interface Props {
  AuditList: AuditRecord[];
  onSelectionChanged: (item: AuditRecord) => any;
}

const AuditDetailList = (props: Props) => {
  const columns: DataGridColumn[] = [
    {
      key: "date",
      name: "Date",
      fieldName: "DateUtc",
      minWidth: 150,
      maxWidth: 150,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
      data: "number",
      onRender: (item: AuditRecord) => {
        return <span>{new Date(item.DateUtc).toLocaleDateString()}</span>;
      },
    },
    {
      key: "time",
      name: "Time",
      fieldName: "DateUtc",
      minWidth: 150,
      maxWidth: 150,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
      data: "number",
      onRender: (item: AuditRecord) => {
        return <span>{new Date(item.DateUtc).toLocaleTimeString()}</span>;
      },
    },
    {
      key: "eventType",
      name: "EventType",
      fieldName: "EventType",
      minWidth: 150,
      maxWidth: 170,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "entityName",
      name: "EntityName",
      fieldName: "EntityName",
      minWidth: 250,
      maxWidth: 260,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "externalId",
      name: "ExternalId",
      fieldName: "ExternalId",
      minWidth: 70,
      maxWidth: 100,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "emailAddress",
      name: "EmailAddress",
      fieldName: "EmailAddress",
      minWidth: 250,
      maxWidth: 350,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "Actions",
      name: "",
      minWidth: 50,
      maxWidth: 70,
      onRender: (item: AuditRecord) => (
        <MoreActionsButton
          menu={[
            {
              key: "details",
              text: "Show record audit",
              iconProps: { iconName: "List" },
              onClick: () => {
                props.onSelectionChanged(item);
              },
            },
          ]}
        />
      ),
    },
  ];

  return (
    <>
      <DataGrid items={props.AuditList} columns={columns} />
    </>
  );
};

export default AuditDetailList;
